import axios from 'axios'
import offline from '../offline/index'
import moment from 'moment'

// Call actions
export default {
  // Read assignments
  readCalls({ state, commit }, opts) {
    offline.getVersion()
    const payload = opts || {}
    const force = payload.force === undefined ? false : payload.force
    if (!state.list || force) {
      const params = payload.data || {}
      // Include history to request
      params.include = payload.include || [
        'history',
        'media',
        'scans',
        'signature'
      ]

      return axios
        .get(process.env.VUE_APP_API_URL + '/assignments', { params: params })
        .then(response => {
          if (force) {
            commit('RESET_STORE')
          }
          let assignments = response.data.data
          let assignmentIds = _.map(assignments, 'id')

          commit('SET_LIST', assignments)

          indexedDB.open('trios').onsuccess = function(event) {
            var db = event.target.result
            var transaction = db.transaction(['assignments'], 'readwrite')
            var objectStore = transaction.objectStore('assignments')
            var request = objectStore.getAll()
            request.onsuccess = function(event) {
              let assignmentsDB = request.result
              assignmentsDB.forEach(request => {
                if (!_.includes(assignmentIds, request.id)) {
                  objectStore.delete(request.id)
                }
              })
            }
          }
          return response
        })
    }
  },

  refreshUserCalls({ state, commit }, payload) {
    const params = {}
    return axios
      .get(
        process.env.VUE_APP_API_URL +
          '/users/sync-my-calls?' +
          new Date().getTime(),
        { params: params }
      )
      .then(response => {
        console.log('Refresh', response)
        return response
      })
  },
  replaceCallList({ commit }, payload) {
    commit('SET_LIST', payload.data)
  },
  // Read single call
  readCall({ commit }, payload) {
    const params = payload && payload.data ? payload.data : {}
    // Include history to request
    params.include = ['history', 'media', 'signature', 'scans']

    return axios
      .get(process.env.VUE_APP_API_URL + '/assignments/' + payload.id, {
        params: params
      })
      .then(response => {
        commit('SET_CALL', response.data.data)
        return response
      })
  },
  // Accept call
  accept({ commit }, payload) {
    const params = _.isFinite(payload) ? { id: payload } : payload
    const assignmentId = params.id
    params.include = ['history']
    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/accept',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, payload)
        commit('ACCEPT_CALL', response.data.data)
        return response
      })
  },
  // Travel call
  travel({ commit }, payload) {
    const params = _.isFinite(payload) ? { id: payload } : payload
    const assignmentId = params.id
    params.include = ['history']
    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/travel',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, params)
        commit('TRAVEL_CALL', response.data.data)
        var dateTime = moment().toISOString()
        var payload = { callId: assignmentId, dateTime: dateTime }
        commit('TRAVEL_START_TIME', payload)
        return response
      })
  },
  // Arrived Call
  arrived({ commit }, payload) {
    const params = _.isFinite(payload) ? { id: payload } : payload
    const assignmentId = params.id
    params.include = ['history']
    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/arrived',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, params)
        commit('ARRIVED_CALL', response.data.data)
        return response
      })
  },
  // Arrival Completed
  arrivalCompleted({ commit }, payload) {
    const params = _.isFinite(payload) ? { id: payload } : payload
    const assignmentId = params.id
    params.include = ['history']
    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/arrival_completed',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, params)
        commit('ARRIVAL_COMPLETED_CALL', response.data.data)
        return response
      })
  },
  // Onsite arrival process
  async onsiteArrivalProcess({ commit }, payload) {
    const params = _.isFinite(payload) ? { callId: payload } : payload
    const assignmentId = params.callId
    params.include = ['history']
    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/arrival',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, params)
        commit('ONSITE_ARRIVAL_PROCESS', response.data.data)
        return response
      })
  },
  // POWRA process
  powraProcess({ commit }, payload) {
    const assignmentId = payload.call_assignment_id
    const params = _.isFinite(payload)
      ? { callAssignmentId: payload.call_assignment_id }
      : payload

    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/risk_assessment',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response)
        return response
      })
  },
  // Create new POWRA version
  newPowraVersion({ commit }, payload) {
    const assignmentId = payload.call_assignment_id
    const params = _.isFinite(payload)
      ? { callAssignmentId: payload.call_assignment_id }
      : payload

    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/risk_assessment/new-powra-version',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response)
        commit('CURRENT_RISK_ASSESSMENT', response.data)

        return response
      })
  },
  // Reset call
  reset({ commit }, payload) {
    const params = _.isFinite(payload) ? { id: payload } : payload
    const assignmentId = params.id
    params.include = ['history']
    return axios
      .post(
        process.env.VUE_APP_API_URL + '/assignments/' + assignmentId + '/reset',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, params)
        commit('RESET_CALL', response.data.data)
        commit('SET_HAS_POWRA', false)
        commit('CURRENT_RISK_ASSESSMENT', {
          fields: {
            hazards: [],
            controls: []
          }
        })
        commit('CLEAR_WORKSHEET')
        commit('CLEAR_COMPLETED_FORMS')
        commit('SET_FORMS_LIST', [])
        return response
      })
  },
  complete({ commit, dispatch }, payload) {
    const assignmentId = payload.id
    const params = payload.data || {}
    if (!params.include) {
      params.include = ['history']
    }
    if (payload.position) {
      params.position = payload.position
    }
    return axios
      .post(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/complete',
        params
      )
      .then(response => {
        // offline.attemptToSyncAssignmentCompletion(response, payload)
        offline.attemptToSyncAssignment(response, params)
        commit('COMPLETE_CALL', response.data.data)
        commit('SET_HAS_POWRA', false)
        commit('CURRENT_RISK_ASSESSMENT', {
          fields: {
            hazards: [],
            controls: []
          }
        })
        commit('CLEAR_WORKSHEET')
        commit('CLEAR_COMPLETED_FORMS')
        commit('SET_FORMS_LIST', [])
        return response
      })
  },
  addVideo({ commit }, payload) {
    const assignmentId = payload.id
    const media = payload.media
    // const collection_name = media.collection_name ? media.collection_name : 'media'
    const url =
      process.env.VUE_APP_API_URL +
      '/assignments/' +
      assignmentId +
      '/' +
      'video'
    const params = _.extend(payload.params || {}, {
      type: media.type,
      name: media.name
    })

    // params.file = media.file
    const data = new FormData()
    data.append('file', media.file, 'file')
    _.each(params, (element, index, list) => {
      data.append(index, element)
    })
    return axios
      .post(url, data, {
        headers: {
          'Content-Type': `multipart/form-data; boundary=${data._boundary}`
        },
        timeout: 30000
      })
      .then(response => {
        if (!payload.offline) {
          // Not offline media, if offline - it means we are trying to send it again and it's in local db already
          commit('ADD_MEDIA', {
            id: assignmentId,
            media:
              response.statusText === 'Cached'
                ? media
                : _.extend(media, response.data.data)
          })
          offline.attemptToSyncAssignment(response, params)
          if (response.statusText === 'Cached') {
            const dataToCache = {
              requestId: response.data.data.requestId,
              data: response.data.data
            }
            dataToCache.data.media = payload.media
            offline.sendDataToOfflineRequest(dataToCache)
          }
        }
        return response
      })
      .catch(e => {})
  },
  depart({ commit }, payload) {
    const id = payload.id
    const params = payload.data || {}
    if (!params.include) {
      params.include = ['history']
    }
    if (payload.position) {
      params.position = payload.position
    }
    return axios
      .post(
        process.env.VUE_APP_API_URL + '/assignments/' + id + '/depart',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, payload)
        commit('DEPART_CALL', response.data.data)
        return response
      })
  },
  endTravel({ commit }, payload) {
    const id = payload.id
    const params = payload.data || {}
    if (!params.include) {
      params.include = ['history']
    }
    if (payload.position) {
      params.position = payload.position
    }
    return axios
      .post(
        process.env.VUE_APP_API_URL + '/assignments/' + id + '/end-travel',
        params
      )
      .then(response => {
        offline.attemptToSyncAssignment(response, payload)
        commit('ENDTRAVEL_CALL', response.data.data)
        commit('SET_HAS_POWRA', false)
        commit('CURRENT_RISK_ASSESSMENT', {
          fields: {
            hazards: [],
            controls: []
          }
        })
        commit('CLEAR_WORKSHEET')
        commit('CLEAR_COMPLETED_FORMS')
        commit('SET_FORMS_LIST', [])
        return response
      })
  },

  updateProgress({ commit }, payload) {
    commit('SET_UPLOAD_PROGRESS', payload)
  },
  setNetworkStatus({ commit }, payload) {
    commit('SET_NETWORK_STATUS', payload)
  },
  cancelRequest({ state, commit }) {
    if (state.axiosRequest) state.axiosRequest.cancel()
    commit('SET_AXIOS_CANCEL_TOKEN', undefined)
  },
  addMedia({ commit }, payload) {
    const assignmentId = payload.id
    const media = payload.media
    const collection_name = media.collection_name
      ? media.collection_name
      : 'media'
    const url =
      process.env.VUE_APP_API_URL +
      '/assignments/' +
      assignmentId +
      '/' +
      collection_name
    const axiosRequest = axios.CancelToken.source()
    commit('SET_AXIOS_CANCEL_TOKEN', axiosRequest)
    const config = {
      onUploadProgress: function(progressEvent) {
        let uploadPercentage = parseInt(
          Math.round((progressEvent.loaded / progressEvent.total) * 100)
        )
        if (uploadPercentage > 10 && uploadPercentage <= 90) {
          commit('SET_UPLOAD_PROGRESS', uploadPercentage)
          console.log(uploadPercentage, 'here uploadPercentage')
        }
      },
      // headers: {
      //   'Content-Type': 'multipart/form-data'
      // }
      cancelToken: axiosRequest.token
    }
    const params = _.extend(payload.params || {}, {
      base64: payload.media.src,
      type: media.type,
      name: media.name,
      collection_name: collection_name,
      custom_properties: {
        stage: media.stage ? media.stage : 'during'
      }
    })
    return axios
      .post(url, params, config)
      .then(response => {
        console.log('offlined??/')
        if (!payload.offline) {
          // Not offline media, if offline - it means we are trying to send it again and it's in local db already
          if (collection_name === 'scans') {
            let newMedia = {}
            Object.assign(newMedia, media)
            commit('ADD_SCAN', {
              id: assignmentId,
              media: _.extend(newMedia, response.data.data)
            })
          } else {
            let newMedia = {}
            Object.assign(newMedia, media)
            commit('ADD_MEDIA', {
              id: assignmentId,
              media: _.extend(newMedia, response.data.data)
            })
          }
          offline.attemptToSyncAssignment(response, params)
        }
        commit('SET_UPLOAD_PROGRESS', 100)
        setTimeout(() => {
          commit('SET_UPLOAD_PROGRESS', undefined)
        }, 100)
        return response
      })
      .catch(error => {
        commit('SET_UPLOAD_PROGRESS', undefined)
        // return 'failed'
        throw error
      })
  },
  updateScanItem({ commit }, payload) {
    commit('UPDATE_SCAN', payload)
  },
  updateMedia({ commit }, payload) {
    const media = payload.media
    const id = media.model_id
    const collection_name = payload.collection_name || 'media'
    const url =
      process.env.VUE_APP_API_URL +
      '/assignments/' +
      id +
      '/' +
      collection_name +
      '/' +
      media.id
    const params = payload.params
    params.offlineMeta = {
      data: { description: payload.params.description }
    }
    if (media.isNew) {
      params.offlineMeta.isNew = media.isNew
    }
    if (media.requestId) {
      params.offlineMeta.requestId = media.requestId
    }
    return axios.put(url, params).then(response => {
      if (!payload.offline) {
        commit('UPDATE_MEDIA', {
          objectId: id,
          mediaId: media.id,
          collection_name: collection_name,
          media:
            response.statusText === 'Cached'
              ? payload.params
              : response.data.data
        })
        payload.id = id
        offline.attemptToSyncAssignment(response, payload.params)
      }
      payload.id = media.id
      return response
    })
  },
  // Delete single call media
  deleteMedia({ commit }, payload) {
    const params = {
      offlineMeta: { isNew: payload.isNew, requestId: payload.requestId }
    }
    const callId = payload.model_id
    const mediaId = payload.id
    const collection_name = payload.collection_name
      ? payload.collection_name
      : 'media'
    return axios({
      method: 'DELETE',
      url:
        process.env.VUE_APP_API_URL +
        '/assignments/' +
        callId +
        '/' +
        collection_name +
        '/' +
        mediaId,
      data: params
    })
      .then(response => {
        if (collection_name === 'scans') {
          commit('DELETE_SCAN', { callId: callId, mediaId: mediaId })
        } else {
          commit('DELETE_MEDIA', { callId: callId, mediaId: mediaId })
        }
        offline.attemptToSyncAssignment(response, params)
        return response
      })
      .catch(error => {
        throw error
      })
  },
  // Replace media
  replaceMedia({ commit }, payload) {
    const collection_name = payload.collection_name
      ? payload.collection_name
      : 'media'
    const id = payload.model_id
    const mediaId = payload.mediaId
    commit('REPLACE_MEDIA', {
      collection_name: collection_name,
      objectId: id,
      mediaId: mediaId,
      media: payload.data
    })
  },
  // Update call signature in store
  updateSignature({ commit }, payload) {
    commit('UPDATE_SIGNATURE', payload)
  },
  visitStatus({ commit }, payload) {
    commit('VISIT_STATUS', payload)
  },
  travelStartTime({ commit }, payload) {
    commit('TRAVEL_START_TIME', payload)
  },
  onSiteTime({ commit }, payload) {
    commit('ON_SITE_TIME', payload)
  },
  offSiteTime({ commit }, payload) {
    commit('OFF_SITE_TIME', payload)
  },
  travelEndTime({ commit }, payload) {
    commit('TRAVEL_END_TIME', payload)
  },
  travelingHome({ commit }, payload) {
    commit('TRAVELING_HOME', payload)
  },
  workCarriedOut({ commit }, payload) {
    commit('WORK_CARRIED_OUT', payload)
  },
  clientName({ commit }, payload) {
    commit('CLIENT_NAME', payload)
  },
  saveSentiment({ commit }, payload) {
    commit('SET_SENTIMENT', payload)
  },
  saveWhySentiment({ commit }, payload) {
    commit('SET_WHY_SENTIMENT', payload)
  },
  clientPosition({ commit }, payload) {
    commit('CLIENT_POSITION', payload)
  },
  // Change postcode of call
  changePostCode({ commit }, payload) {
    commit('SET_CALL', {
      id: payload.call.id,
      postcode: payload.postcode,
      destination: null
    })
  },
  geoCodeAddress({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const geocoder = new window.google.maps.Geocoder()
      geocoder.geocode(
        {
          address: payload.address
        },
        function(results, status) {
          if (status === 'OK') {
            payload.destination = new window.google.maps.LatLng({
              latitude: results[0].geometry.location.lat(),
              longitude: results[0].geometry.location.lng()
            })
            commit('SET_CALL_DESTINATION', payload)
            resolve(payload)
          } else {
            console.log(
              'Geocode was not successful for the following reason: ' + status
            )
            reject(results)
          }
        }
      )
    })
  },
  setHasPowra({ commit }, payload) {
    commit('SET_HAS_POWRA', payload)
  },

  setHasWorksheet({ commit }, payload) {
    console.log('Setting hasWorksheet')
    commit('SET_HAS_WORKSHEET', payload)
  },

  addCompletedCallForm({ commit }, payload) {
    console.log('Setting Completed Call Form')
    commit('ADD_COMPLETED_CALL_FORM', payload)
  },

  saveRiskAssessmentHazards({ commit }, payload) {
    commit('SAVE_RISK_ASSESSMENT_HAZARDS', payload)
  },

  saveRiskAssessmentControls({ commit }, payload) {
    commit('SAVE_RISK_ASSESSMENT_CONTROLS', payload)
  },
  saveRiskAssessmentHazardsControls({ commit }, payload) {
    commit('SAVE_RISK_ASSESSMENT_HAZARDS_CONTROLS', payload)
  },

  fetchCurrentRiskAssessment({ commit }, payload) {
    const params = _.isFinite(payload) ? { callId: payload } : payload
    const assignmentId = params.call_assignment_id
    params.include = ['history']

    return axios
      .get(
        process.env.VUE_APP_API_URL +
          '/assignments/' +
          assignmentId +
          '/risk_assessment/current-powra',
        params
      )
      .then(response => {
        commit('CURRENT_RISK_ASSESSMENT', response.data)
      })
  },

  fetchForms({ commit }, payload) {
    const params = payload.data || {}

    let form_templates = payload.data.formTemplates
    commit('SET_FORMS_LIST', form_templates)
    return form_templates
  },

  fetchPurchaseOrders({ commit }, payload) {
    const params = payload.data || {}
    console.log(payload)
    return axios
      .post(process.env.VUE_APP_API_URL + '/purchase-orders/fetch', {
        params: payload
      })
      .then(response => {
        commit(
          'SET_PURCHASE_ORDERS_LIST',
          response.data,
          payload.call_assignment_id
        )
        return response.data
      })
  },

  updateFormSchemas({ commit }, payload) {
    commit('UPDATE_FORM_SCHEMAS', payload)
  },

  updateFormData({ commit }, payload) {
    commit('UPDATE_LARAFORM_STORE', payload)
  },

  setSelectedFormId({ commit }, formId) {
    commit('SET_SELECTED_FORM_ID', formId.trim())
  }
}
